import { Col, Row } from "antd";
import { TimeDataType } from "../../Times";
import { CheckTag } from "./index.styled";

interface TimesTagProps {
  times: TimeDataType[];
  selectedTimes?: moment.Moment[];
  type?: "default" | "disabled";
}
/**
 * 시간 선택 정보 (preview 용)
 * @returns
 */
export const TimesTag: React.FC<TimesTagProps> = ({
  times = [],
  selectedTimes = [],
  type = "default",
}) => {
  return (
    <Row gutter={[4, 4]} align="top" style={{ justifyItems: "stretch" }}>
      {times.map(({ time, disabled }, index) => (
        <Col key={`times-${index}`}>
          <CheckTag
            $type={type}
            checked={selectedTimes.findIndex((k) => time.isSame(k)) > -1}
            disabled={disabled}
          >
            {time.format("HH:mm")}
          </CheckTag>
        </Col>
      ))}
    </Row>
  );
};
